// extracted by mini-css-extract-plugin
export default {"Popup":"style_Popup__eYZF8","button":"style_button__pOUz-","text":"style_text__g+lok"};